import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class AboutV3 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="ltn__about-us-area pt-115 pb-100 ">
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-6 align-self-center">
			        <div className="about-us-img-wrap about-img-left">
			          <img src={publicUrl+"assets/img/about/about-1.webp"} alt="About Us Image" />
			          <div className="about-us-img-info about-us-img-info-2 about-us-img-info-3 d-none">
			            <div className="ltn__video-img ltn__animation-pulse1">
			              <img src={publicUrl+"assets/img/about/about-1.webp"} alt="video popup bg image" />
			              <a className="ltn__video-icon-2 ltn__video-icon-2-border---" href="" data-rel="lightcase:myCollection">
			                <i className="fa fa-play" />
			              </a>
			            </div>
			          </div>
			        </div>
			      </div>
			      <div className="col-lg-6 align-self-center">
			        <div className="about-us-info-wrap">
			          <div className="section-title-area ltn__section-title-2--- mb-30">
			            <h2 className="section-subtitle section-subtitle-2--- ltn__secondary-color">About Us</h2>
			            {/* <h1 className="section-title">Who We Are?</h1> */}
			            <p>C.N. Balakumar began his journey as a marketer at the remarkable age of 15. Driven by passion and determination, he established his own proprietorship at 21 years old. His unwavering commitment, relentless hard work, and dedication to customer satisfaction have been the cornerstones of his success.
                          Today, Under his leadership, a talented team of 25 employees serves over 1,000+ delighted customers, continuing to uphold the values that define our organization. C.N. Balakumar’s visionary approach continues to inspire and shape the future of our business.
                          Beyond business, C.N. Balakumar has always believed in giving back to society. His social service initiatives reflect his deep sense of responsibility and compassion.</p>
			          </div>                        
			          
			        </div>
			      </div>
				  <div className="col-lg-12 mt-4 align-center">
				    <div className="row">
						
						<div className="col-lg-4">
						<div className="ltn__feature-item ltn__feature-item-3">
			            <div className="ltn__feature-icon">
			              <span><i className="flaticon-call-center-agent" /></span>
			            </div>
			            <div className="ltn__feature-info">
			              <h4><a href="service-details.html">Vision</a></h4>
			              <p>"To be the most trusted real estate partner, empowering our customers to achieve their property
						  goals while fostering growth, opportunity, and development for our employees.We are committed to
						  building thriving communities.</p>
			            </div>
			          </div>
						</div>
						<div className="col-lg-4">
						<div className="ltn__feature-item ltn__feature-item-3">
			            <div className="ltn__feature-icon">
			              <span><i className="flaticon-house-4" /></span>
			            </div>
			            <div className="ltn__feature-info">
			              <h4><a href="service-details.html">Mission</a></h4>
			              <p>"To deliver exceptional real estate experiences by trust and long-term relationships with our
                  customers, supporting the personal and professional growth of our employees, and contributing to the
                  sustainable development of the communities.</p>
			            </div>
			          </div>
						</div>
						<div className="col-lg-4">
						<div className="ltn__feature-item ltn__feature-item-3">
			            <div className="ltn__feature-icon">
			              <span><i className="flaticon-book" /></span>
			            </div>
			            <div className="ltn__feature-info">
			              <h4><a href="service-details.html">Quality Policy</a></h4>
			              <p>"At Success Property Enterprises, we are committed to providing our customers with high-quality,
                  affordable real estate solutions that meet their needs and exceed their expectations. Our goal is to
                  offer prime land and property options at competitive prices.</p>
			            </div>
			          </div>
						</div>
					</div>
			          
			          
				  </div>
			    </div>
			  </div>
			</div>
        }
}

export default AboutV3